import React, { useEffect, useRef, useState } from 'react';
import { COLOR } from '@src/styles/color';
import { formatAudioTime } from '@src/utils/time';
import CommonButton from '@src/new-components/Button';
import { truncateFilename } from '@src/services/instantVoiceCloning';
import Typography from '@src/new-components/Typography';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import PauseRoundedIcon from '@mui/icons-material/PauseRounded';
import {
  StyledAudioInfo,
  StyledAudioPlayer,
  StyledPreviewAudio,
} from '@src/containers/VoiceCloneInput/PreviewAudio/index.style';
import RecordAgain from './RecordAgain';

const PreviewAudio = ({
  metadataAudio,
  audioError,
  handleReset,
  loadingVerifyVoice,
  verifyYourVoice,
  voiceCheckStatus,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);

  const audioRef = useRef(null);

  useEffect(() => {
    if (!isPlaying) {
      audioRef.current?.pause();
    } else {
      audioRef.current?.play();
    }
  }, [isPlaying]);

  const handlePlayPause = () => {
    if (!metadataAudio?.audioLink) return;
    setIsPlaying((prev) => !prev);
  };

  const handleAudioEnded = () => {
    setIsPlaying(false);
  };

  const handleLoadedMetadata = (e) => {
    if (metadataAudio?.recordTime) {
      setDuration(metadataAudio?.recordTime);
    } else {
      setDuration(e.target.duration);
    }
  };

  return (
    <StyledPreviewAudio>
      <StyledAudioPlayer>
        <CommonButton
          onClick={handlePlayPause}
          variant="contained"
          color="primary"
          sx={{
            borderRadius: '50%',
            minWidth: '40px !important',
            minHeight: '40px !important',
            padding: '0 !important',
          }}
          disabled={!metadataAudio?.audioLink}
        >
          {isPlaying ? <PauseRoundedIcon /> : <PlayArrowRoundedIcon />}
        </CommonButton>
        <StyledAudioInfo>
          <Typography
            component="span"
            variant="body-16-medium"
            color={COLOR.black.default}
          >
            {truncateFilename({
              filename: metadataAudio?.fileName,
              maxLength: 25,
              maxLengthExt: 5,
              maxLengthName: 20,
            })}
          </Typography>
          <Typography
            component="span"
            variant="body-14-regular"
            color={COLOR.descriptionUpload}
          >
            {formatAudioTime(duration)}
          </Typography>
        </StyledAudioInfo>
        <audio
          ref={audioRef}
          src={metadataAudio?.audioLink}
          onEnded={handleAudioEnded}
          onLoadedMetadata={handleLoadedMetadata}
          style={{ display: 'none' }}
        >
          <track kind="captions" />
        </audio>
      </StyledAudioPlayer>

      <RecordAgain
        audioError={audioError}
        handleReset={handleReset}
        loadingVerifyVoice={loadingVerifyVoice}
        verifyYourVoice={verifyYourVoice}
        voiceCheckStatus={voiceCheckStatus}
      />
    </StyledPreviewAudio>
  );
};

export default PreviewAudio;
